import { useQuery } from '@tanstack/react-query';

import { supabase } from '@/integrations/supabase/client';

export interface PostPlanLink {
  projectId: string;
  planName: string | null;
}

/**
 * The plan a post belongs to, resolved `social_posts.plan_slot_id` →
 * `project_tasks.project_id` → `projects.name`. Read-only; null when the post
 * was not made from a plan slot (or the slot is no longer readable).
 */
export function usePostPlanLink(planSlotId: string | null | undefined) {
  return useQuery<PostPlanLink | null>({
    queryKey: ['post-plan-link', planSlotId ?? null] as const,
    enabled: Boolean(planSlotId),
    staleTime: 60_000,
    queryFn: async () => {
      if (!planSlotId) return null;
      const { data, error } = await supabase
        .from('project_tasks')
        .select('project_id, projects(name)')
        .eq('id', planSlotId)
        .maybeSingle();
      if (error) throw error;
      if (!data?.project_id) return null;
      const project = data.projects as { name?: string | null } | null;
      return { projectId: data.project_id, planName: project?.name?.trim() || null };
    },
  });
}
